"use strict";

exports.__esModule = true;
exports.PivotByTimeFilter = PivotByTimeFilter;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function PivotByTimeFilter(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path,
    selectedAggregates = props.selectedAggregates;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.PivotByTime.label",
    label: translate("MetricTableFields.PivotByTime.label", "Enable"),
    checked: !selectedAggregates.reduce(function (acc, agg) {
      return acc && agg.groupId !== "workday";
    }, true) && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "pivotByTime", e.target.checked);
    },
    disabled: selectedAggregates.reduce(function (acc, agg) {
      return acc && agg.groupId !== "workday";
    }, true)
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ShowAverageColumn.label",
    label: translate("MetricTableFields.ShowAverageColumn.label", "Show Average Column"),
    checked: element.props.showAverageColumn && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showAverageColumn", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ShowTotalColumn.label",
    label: translate("MetricTableFields.ShowTotalColumn.label", "Show Total Column"),
    checked: element.props.showTotalColumn && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showTotalColumn", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ShowHeatMap.label",
    label: translate("MetricTableFields.ShowHeatMap.label", "Show Heat Map"),
    checked: element.props.showHeatMap && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showHeatMap", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ShowChangeColumn.label",
    label: translate("MetricTableFields.ShowChangeColumn.label", "Show Change Column"),
    checked: element.props.showChangeColumn && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showChangeColumn", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ShowTrendColumn.label",
    label: translate("MetricTableFields.ShowTrendColumn.label", "Show Trend Column"),
    checked: element.props.showTrendColumn && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showTrendColumn", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ShowTargets.label",
    label: translate("Chart.showTargets", "Show Targets"),
    checked: element.props.showTargets && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showTargets", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    "data-testid": "MetricTableFields.ExcludeZeroValues.label",
    label: translate("MetricTableFields.ExcludeZeroValues.label", "Exclude Zero Values"),
    checked: element.props.excludeZeroValues && element.props.pivotByTime,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "excludeZeroValues", e.target.checked);
    },
    disabled: !element.props.pivotByTime
  }));
}